const buildDataAttributes = ({ data }) => {
  if (!data) return {};
  const dataKeys = Object.keys(data);
  const dataAttributes = {};
  dataKeys.forEach((dataKey) => {
    dataAttributes[`data-${dataKey}`] = data[dataKey];
  });
  return dataAttributes;
};
export {
  buildDataAttributes as default
};
//# sourceMappingURL=buildDataAttributes.es.js.map
